import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Cluster } from '../clusters.models';
import { QueryParams } from '../../models/http.models';
import { environment } from '../../../environments/environment';
import { CustomHeaders, ListParams } from '../../common/helper/query-params-generic-list.helper';

@Injectable({
  providedIn: 'root',
})
export class ClustersResource {
  private apiRoot: string = `${environment.API_URL}`;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  get(cluster_id: number, params?: ListParams, headers?: CustomHeaders): Observable<Cluster> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Cluster>(`${this.apiRoot}/${account_id}/api/clusters/${cluster_id}`, {
          params: params as QueryParams,
          headers: headers as HttpHeaders,
        }),
      ),
    );
  }

  save(body: Partial<Cluster>, params?: ListParams): Observable<Cluster> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.post<Cluster>(`${this.apiRoot}/${account_id}/api/clusters`, body, { params: params as QueryParams }),
      ),
    );
  }

  update(cluster_id: number, body: Partial<Cluster>, params?: ListParams): Observable<Cluster> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<Cluster>(`${this.apiRoot}/${account_id}/api/clusters/${cluster_id}`, body, {
          params: params as QueryParams,
        }),
      ),
    );
  }

  remove(cluster_id: number, params?: ListParams): Observable<Cluster> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.delete<Cluster>(`${this.apiRoot}/${account_id}/api/clusters/${cluster_id}`, {
          params: params as QueryParams,
        }),
      ),
    );
  }

  query(params?: ListParams): Observable<Cluster[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Cluster[]>(`${this.apiRoot}/${account_id}/api/clusters`, { params: params as QueryParams }),
      ),
    );
  }

  search(params?: ListParams): Observable<Cluster[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Cluster[]>(`${this.apiRoot}/${account_id}/api/clusters/search`, {
          params: params as QueryParams,
        }),
      ),
    );
  }
}
